import React, { useEffect, useState } from 'react';
import './Home.css'
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Rightpanel from '../components/Rightpanel';
import HomeMain from '../components/HomeMain';
import Setting from '../components/Setting';
import { auth } from '../firebase'
import { onAuthStateChanged } from 'firebase/auth'
import Documents from '../components/Documents';
import MyCourses from '../components/MyCourses';

export default function Home() {
  const [myauth, setmyauth] = useState(null);
  const [activeNav, setActiveNav] = useState('Home');
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([
    { id: 1, title: 'UI/UX Design discussion', date: 'Tomorrow, 10:00 AM', completed: false },
    { id: 2, title: 'Submit Animation wireframe', date: 'Oct 24, 2026', completed: false },
    { id: 3, title: 'Photography portfolio review', date: 'Oct 27, 2026', completed: true }
  ]);

  // Sync user auth data with backend database
  const syncUserWithBackend = async (user) => {
    try {
      const response = await fetch('https://mmao.vercel.app/sync/user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL
        }),
      });
      const result = await response.json();
      if (result.status === 'success') {
      } else {
        console.warn('Failed to sync user:', result.text);
      }
    } catch (err) {
      console.error('Error connecting to sync user API:', err);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      if (u) {
        setmyauth(u);
        // Call sync function whenever auth state is detected or updated
        syncUserWithBackend(u);
      } else {
        setmyauth(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleTaskToggle = (id) => {
    setTasks(tasks.map(t => t.id === id ? { ...t, completed: !t.completed } : t));
  };

  return (
    <div className="dashboard-container">
      <Sidebar activeNav={activeNav} setActiveNav={(e) => { setActiveNav(e) }} />
      {activeNav === 'Home' && <HomeMain myauth={myauth} activeNav={activeNav} setActiveNav={(e) => { setActiveNav(e) }} />}
      {activeNav === 'My courses' && <MyCourses myauth={myauth} activeNav={activeNav} setActiveNav={(e) => { setActiveNav(e) }}/>}
      {activeNav === 'Profile' && <Setting activeNav={activeNav} setActiveNav={(e) => { setActiveNav(e) }}/>}
      {activeNav === 'Documents' && <Documents activeNav={activeNav} setActiveNav={(e) => { setActiveNav(e) }}/>}
      <Rightpanel myauth={myauth} />

      {upgradeModalOpen && (
        <div className="modal-overlay" onClick={() => setUpgradeModalOpen(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <h3>Unlock Pro Membership</h3>
            <p>Get unrestricted access to exclusive courses, mentorship sessions, and offline downloads for $12/month.</p>
            <button className="modal-close-btn" onClick={() => setUpgradeModalOpen(false)}>Upgrade Now</button>
          </div>
        </div>
      )}

      {joinModalOpen && (
        <div className="modal-overlay" onClick={() => setJoinModalOpen(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <h3>Join New Course</h3>
            <p>Explore our catalog of 200+ masterclasses and enroll instantly.</p>
            <button className="modal-close-btn" onClick={() => setJoinModalOpen(false)}>Explore Catalog</button>
          </div>
        </div>
      )}
    </div>
  );
}